module.exports = __webpack_public_path__ + "img/gallery-6.630a9b06.jpg";